import { render, staticRenderFns } from "./StatTarget.vue?vue&type=template&id=560d00bb&scoped=true&"
import script from "./StatTarget.vue?vue&type=script&lang=js&"
export * from "./StatTarget.vue?vue&type=script&lang=js&"
import style0 from "./StatTarget.vue?vue&type=style&index=0&id=560d00bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560d00bb",
  null
  
)

export default component.exports